import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Button, Text} from '@chakra-ui/react3'
import {ShoppingCartIcon} from '../../../../../leap/components/icons'
import logger from '../../../../../utils/logger-instance'

// Maps partner brands from redirectLinkPartnerAllProducts to leap color tokens
const PARTNER_COLOR_MAP = {
    babybunting: 'partner.babybunting'
}

/**
 * Resolves a partner color preference value to the configured theme color token
 * for a leap surface.
 *
 * @param {string} colorKey
 * @returns {string|null}
 */
const resolvePartnerColor = (colorKey) => {
    if (!colorKey) return null

    const key = colorKey.trim().toLowerCase().split('.').pop()
    const token = PARTNER_COLOR_MAP[key]

    if (!token) {
        logger.error(`Unknown partner color key "${key}"`)
        return null
    }

    return token
}

const PartnerRedirectBtn = ({redirectProps, ...props}) => {
    const {formatMessage} = useIntl()
    const {onOpen, onClick, partnerLink, partnerBrandButtonColor} = redirectProps
    const resolvedPartnerButtonColor = useMemo(
        () => resolvePartnerColor(partnerBrandButtonColor),
        [partnerBrandButtonColor]
    )
    const partnerLabel = formatMessage({
        id: 'partner-link.label',
        defaultMessage: 'Shop with our partner'
    })

    return (
        <Button
            size="lg"
            variant="primaryFilled"
            {...(partnerLink &&
                !onOpen && {
                    as: 'a',
                    href: partnerLink,
                    target: '_blank',
                    rel: 'noopener noreferrer'
                })}
            aria-label={partnerLabel}
            onClick={onOpen ?? onClick}
            {...(resolvedPartnerButtonColor
                ? {
                      bg: resolvedPartnerButtonColor,
                      _hover: {bg: resolvedPartnerButtonColor, filter: 'brightness(0.9)'}
                  }
                : {})}
            {...props}
        >
            <Text>{partnerLabel}</Text>
            <ShoppingCartIcon color="icons.on-color" />
        </Button>
    )
}

PartnerRedirectBtn.propTypes = {
    redirectProps: PropTypes.object
}

export default PartnerRedirectBtn
